import React, { ChangeEvent } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { StyledDropdownWithLabel } from './SearchInitiationMobile.styles';
import { getTranslator } from '../../i18n/getTranslator';
import searchTranslations from 'public/locales/en/search.json';
import {
    DropdownWrapper,
    RightWrapper,
    LeftWrapper
} from '../../../search/common/Dropdown.styles';
import {
    SelectBedsMinOptions,
    SelectBedsMaxOptions
} from '../../../search/common/SelectBedsOptions';
import {
    updateFilter,
    bedsMinSelector,
    bedsMaxSelector
} from '../../../reducers/filters';
import { FilterWrapper } from './SearchInitiationMobile.styles';

const t = getTranslator(searchTranslations);
export const SelectBeds = () => {
    const reduxDispatch = useDispatch();
    const {
        selectedValue: bedsMinSelectedValue,
        options: bedsMinOptions
    } = useSelector(bedsMinSelector);
    const {
        selectedValue: bedsMaxSelectedValue,
        options: bedsMaxOptions
    } = useSelector(bedsMaxSelector);

    const onMaxBedsChange = (evt: ChangeEvent<HTMLSelectElement>) => {
        const {
            currentTarget: { value }
        } = evt;

        reduxDispatch(updateFilter('maxBedrooms', value));
    };

    const onMinBedsChange = (evt: ChangeEvent<HTMLSelectElement>) => {
        const {
            currentTarget: { value }
        } = evt;

        reduxDispatch(updateFilter('minBedrooms', value));
    };

    const bedsMinInt = parseInt(bedsMinSelectedValue, 10);
    const bedsMaxInt = parseInt(bedsMaxSelectedValue, 10);

    const minBedsLabel = t('filters.minBedsLabelModal');
    const bedsOptionsLabel = t('filters.field.beds.label');
    const maxBedsLabel = t('filters.maxBedsLabelModal');

    return (
        <FilterWrapper>
            <DropdownWrapper>
                <LeftWrapper>
                    <StyledDropdownWithLabel
                        id="mobile_beds_min"
                        onChange={onMinBedsChange}
                        value={bedsMinSelectedValue}
                        name="beds_min"
                        aria-label="Min Beds"
                        data-testid="min_beds_testid_mobile"
                        label={minBedsLabel}
                        hasBorderRadius
                    >
                        {bedsMinOptions ? (
                            <SelectBedsMinOptions
                                bedsOtherInt={bedsMaxInt}
                                options={bedsMinOptions}
                                keyPrefix="modal-min-beds"
                            />
                        ) : (
                            <option>{bedsOptionsLabel}</option>
                        )}
                    </StyledDropdownWithLabel>
                </LeftWrapper>
                <RightWrapper>
                    <StyledDropdownWithLabel
                        onChange={onMaxBedsChange}
                        value={bedsMaxSelectedValue}
                        id="beds_max"
                        name="beds_max"
                        aria-label="Max Beds"
                        data-testid="max_beds_testid_mobile"
                        label={maxBedsLabel}
                        hasBorderRadius
                    >
                        {bedsMaxOptions ? (
                            <SelectBedsMaxOptions
                                bedsOtherInt={bedsMinInt}
                                options={bedsMaxOptions}
                                keyPrefix="modal-max-beds"
                            />
                        ) : (
                            <option>{bedsOptionsLabel}</option>
                        )}
                    </StyledDropdownWithLabel>
                </RightWrapper>
            </DropdownWrapper>
        </FilterWrapper>
    );
};
